import { createStateHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useAcceptInvitationState = createStateHook(
  AppStoreProvider,
  state => state.pages.acceptInvitation
)
